// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1Ua1E","header":"PatientBlock_header__3fcKj","label":"PatientBlock_label__1p2R7","option":"PatientBlock_option__2sntF"};